import React from "react";

import { List, ListItem } from "@mui/material";

import { ChevronIcon } from "@/assets/icons";
import { SpinLoader } from "@/components/atoms";

import { StyledListItemButton, StyledListItemText } from "./styled";

export type Item<Id> = {
    id: Id;
    label: string;
};

type ItemListProps<Id> = {
    items: Item<Id>[];
    onSelectItem: (id: Id) => void;
};

const ItemList = <Id = string,>({ items, onSelectItem }: ItemListProps<Id>): React.ReactElement => {
    return (
        <>
            {(!items || items.length === 0) && <SpinLoader />}
            <List>
                {items.map(({ id, label }) => (
                    <ListItem key={id.toString()}>
                        <StyledListItemButton onClick={() => onSelectItem(id)} dense data-testid={`item-${id}`}>
                            <StyledListItemText primary={label} />
                            <ChevronIcon />
                        </StyledListItemButton>
                    </ListItem>
                ))}
            </List>
        </>
    );
};

export default ItemList;
